import requests from "utils/httpService";

const getRequests = {
  getGiftCards: (merchantId) =>
    requests.manageServiceRequests.get(
      `/loyalties/loyalty/rewards/published/list/${merchantId}`
    ),
  getGiftCardsCategories: (merchantId) =>
    requests.loyaltyRequests.get(
      `/admin/discounts/category/list/${merchantId}`
    ),
  getCustomerRecentLoyaltyPoints: ({ merchant, customer_phone, order }) =>
    requests.manageServiceRequests.get(
      `/orders/order/process/${merchant}/customer/${customer_phone}/${order}`
    ),
  getUserLoyaltyPoints: ({ customer_id, merchant }) =>
    requests.loyaltyRequests.get(`/admin/wallet/${customer_id}/${merchant}`),
  getCustomerRedeemedVouchers: ({ merchant, phone }) =>
    requests.loyaltyRequests.get(
      `admin/discounts/voucher/customer/claims/all/${merchant}/${phone}`
    ),
  getCustomerTransactions: ({ merchant, customer_id }) =>
    requests.loyaltyRequests.get(
      `/admin/transactions/merchant/${merchant}/user/${customer_id}`
    ),
  checkUser: (mobileNumber) =>
    requests.manageServiceRequests.get(
      `/customers/customer/lookup/${mobileNumber}`
    ),
  getMerchantDetails: (merchantId) => {
    return requests.manageServiceRequests.get(
      `/merchants/gateway/profile/ID/${merchantId}`
    );
  },
  getLoyaltyConfig: () => {
    const token = localStorage.getItem("emsToken");
    return requests.enhancedManageServiceRequests.get(
      `/loyalties/merchants/loyalty`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getCustomerLoyalty: ({ customer_id, merchant }) => {
    return requests.loyaltyRequests.get(
      `/admin/wallet/${customer_id}/${merchant}`
    );
  },
  getLoyaltyHistory: ({ merchantId, userId, startDate, endDate }) => {
    return requests.loyaltyRequests.get(
      `/admin/transactions/merchant/${merchantId}/user/${userId}/${startDate}/${endDate}`
    );
  },
  getCustomerWallets: ({ customer_id }) => {
    return requests.manageServiceRequests.get(
      `/customers/customer/property/wallets/${customer_id}`
    );
  },
  getTransactionFees: ({ merchant, amount, channel }, { headers }) => {
    return requests.manageServiceRequests.get(
      `/vendors/service/charge/${channel}/${amount}/${merchant}`,
      {
        headers,
      }
    );
  },
  getStoreOutlets: ({ merchantId }) => {
    return requests.manageServiceRequests.get(
      `/stores/merchant/${merchantId}/store/outlets/all/list`
    );
  },
  getDeliveryHours: ({ merchantId, outletId }) => {
    return requests.manageServiceRequests.get(
      `/admin/deliveryHours/${merchantId}/${outletId}`
    );
  },
  getDeliveryWindows: ({ merchantId, outletId }) => {
    return requests.deliveryRequests.get(
      `/admin/deliveryWindows/${merchantId}/${outletId}`
    );
  },
  getDeliveryLov: ({ merchantId, outletId }) => {
    return requests.manageServiceRequests.get(
      `/orders/delivery/route/${merchantId}/${outletId}/lov/alt`
    );
  },
  getDeliveryType: ({ user: userDetails }) => {
    return requests.manageServiceRequests.get(
      `/orders/merchant/options/${userDetails["user_merchant_id"]}/alt`
    );
  },
  getMerchantDistanceCharge: (values) => {
    return requests.manageServiceRequests.get(
      `/orders/order/process/delivery/route/distance/charge/alt`,
      values
    );
  },
  getGiftCardRewards: (level_id) => {
    const token = localStorage.getItem("emsToken");
    return requests.enhancedManageServiceRequests.get(
      `/stores/merchant/store/loyalty/${level_id}/products`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  verifyTransaction: ({ merchant_code, trxID }) => {
    return requests.manageServiceRequests.get(
      `/paybills/payment/mobile/status/${merchant_code}/${trxID}`
    );
  },
};

export default getRequests;
